import { AuthService } from '../auth.service';
import { HttpErrorResponse } from '../../../node_modules/@angular/common/http';
import { BaseComponent } from '../components/common/baseComponent/base.component';

export abstract class BaseLoginComponent extends BaseComponent {

  constructor(public authService: AuthService) {
    super();
  }

  public getErrorResponse(
    error: HttpErrorResponse,
    defaultMessage?: string
  ): string {
    let errorMsg: string;
    if (error.status === 401 || error.status === 403) {
      // let errorObj = error.json() as HttpResponseError;
      let errorObj = error.error;
      errorMsg =
        errorObj && errorObj.message ? errorObj.message : defaultMessage;
    } else {
      if (error.message) {
        errorMsg = error.message;
      } else {
        errorMsg = 'Se produjo un error al acceder a la aplicación.';
      }
    }
    return errorMsg;
  }
}
